import React from 'react';

function NavigatingFileTreeContent() {
  return (
    <>
      <p>After opening a workspace, the panel on the left displays your project's file structure.</p>
      
      <h3>Basic Navigation</h3>
      <ul>
        <li>Click the arrow icons (▶︎/▼) or on the folder name itself to expand or collapse a folder</li>
        <li>Files within folders are displayed with appropriate file type icons</li>
        <li>Use the scrollbar to move through larger file structures</li>
      </ul>
      
      <h3>Folder Structure</h3>
      <p>The file tree displays a hierarchical view of your project, similar to what you'd see in your system's file explorer or IDE:</p>
      <ul>
        <li>Root folder (your workspace)</li>
        <li>Subfolders (nested according to your project structure)</li>
        <li>Files (shown within their parent folders)</li>
      </ul>
      
      <p>This familiar tree structure makes it easy to locate specific files or understand the organization of your project.</p>      
    </>
  );
}

export default NavigatingFileTreeContent;